import { render, staticRenderFns } from "./visualizarEquipos.vue?vue&type=template&id=2555ff90&scoped=true&"
import script from "./visualizarEquipos.vue?vue&type=script&lang=js&"
export * from "./visualizarEquipos.vue?vue&type=script&lang=js&"
import style0 from "./visualizarEquipos.vue?vue&type=style&index=0&id=2555ff90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2555ff90",
  null
  
)

export default component.exports